import Main from 'components/Main'
import { withRouter } from 'react-router-dom'

if (typeof window === 'undefined') {
  global.window = {} // needs to prevent errors with rendering components on server side
}

export default withRouter(Main)
